import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { Route, useHistory } from 'react-router-dom';


const ProtectedRoute = ({ ...args }) => {
  const { isAuthenticated } = useAuth0();
  setTimeout(() => {
    if (!isAuthenticated) {
      history.push('/');
    }
  }, 3000);

  const history = useHistory();
  return isAuthenticated ?
    <Route {...args} /> :
    <Box p={5}>
      <Typography variant="body1">Sin autorización, serás redirigido en 3 segundos...</Typography>
    </Box>;
};

ProtectedRoute.propTypes = {
  component: PropTypes.func,
};


export { ProtectedRoute };
